export default __webpack_public_path__ + "static/media/g-5.aafd6698.jpg";